module.exports = __webpack_public_path__ + "ae6ced9c791c9d161dd7af08b1c74d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/senior_report/assets/A+@2x.png
// module id = 298
// module chunks = 0